import { withChartLayout } from 'components/common';
import HistoryPhysical from 'components/features/chart/provider-chart/history-physical/HistoryPhysical';

const HistoryPhysicalPage = withChartLayout('History and Physical')(HistoryPhysical);
export default HistoryPhysicalPage;
